import React from 'react';

export const Card = ({ className = '', children, ...props }) => {
  return (
    <div
      className={`rounded-lg border border-gray-200 dark:border-gray-900 bg-white dark:bg-[#1e1e1e] text-gray-950 dark:text-gray-50 shadow-sm ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardHeader = ({ className = '', children, ...props }) => {
  return (
    <div
      className={`flex flex-col space-y-1.5 p-6 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardContent = ({ className = '', children, ...props }) => {
  return (
    <div className={`p-6 pt-0 ${className}`} {...props}>
      {children}
    </div>
  );
};
